module.exports = __webpack_public_path__ + "static/img/fwicon.6fab092.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/B1/fwicon.png
// module id = 3QGq
// module chunks = 0